import React, { useState } from 'react';
import PropTypes from 'prop-types';
import NoResultsHeader from './NoResultsHeader';
import NoResultsIllustration from './NoResultsIllustration';
import NoResultsContent from './NoResultsContent';
import './NoResults.scss';

const NoResults = ({ isNoResults, onRangeChange }) => {
	// Initialize range from URL parameter, fallback to 50
	const getInitialRange = () => {
		if (typeof window !== 'undefined') {
			const urlParams = new URLSearchParams(window.location.search);
			const rangeParam = urlParams.get('range');
			return rangeParam ? parseInt(rangeParam, 10) : 50;
		}
		return 50;
	};

	const [currentRange, setCurrentRange] = useState(getInitialRange);

	// Handle range change and notify parent
	const handleRangeChange = (newRange) => {
		setCurrentRange(newRange);
		if (onRangeChange) {
			onRangeChange(newRange);
		}
	};

	if (!isNoResults) return null;

	return (
		<div className="locations-no-results d-flex flex-column align-items-center justify-content-center text-center p-4">
			<NoResultsHeader />
			<NoResultsIllustration />
			<NoResultsContent
				currentRange={currentRange}
				onRangeChange={handleRangeChange}
			/>
		</div>
	);
};

NoResults.propTypes = {
	isNoResults: PropTypes.bool.isRequired,
	onRangeChange: PropTypes.func
};

export default NoResults;
